import React, { useState } from 'react';

import styles from './FillIn.module.css';

interface FillInProps {
  content?: string | null;
  onChange?: (newValue: string) => void;
}

const FillIn: React.FunctionComponent<FillInProps> = ({ content, onChange }) => {
  const [value, setValue] = useState(content || '');

  const valueChanged = (element: React.ChangeEvent<HTMLInputElement>) => {
    const newContent = element.target.value;
    setValue(newContent);
    onChange && onChange(newContent);
  };

  const placeholder = '';

  return (
    <input
      className={styles.fillIn}
      onChange={valueChanged}
      placeholder={placeholder}
      value={value}
    />
  );
};

FillIn.displayName = 'FillIn';

export default FillIn;
